export function formatDistanceKm(value) {
  const n = Number(value);
  if (!Number.isFinite(n)) return "";
  return `${n.toFixed(2).replace(".", ",")} km`;
}

// "2026-10-26" -> "26/10/2026" (sem new Date, para não mudar o dia por fuso)
function formatDateBR(date) {
  const m = String(date || "").match(/^(\d{4})-(\d{2})-(\d{2})/);
  return m ? `${m[3]}/${m[2]}/${m[1]}` : String(date || "");
}

// 1345 | "1345" | "13:45" -> "13:45 UTC"
function formatTimeUTC(time) {
  if (time == null || time === "") return "";
  const raw = String(time);
  if (raw.includes(":")) return `${raw.slice(0, 5)} UTC`;
  const s = raw.padStart(4, "0");
  return `${s.slice(0, 2)}:${s.slice(2, 4)} UTC`;
}

export function formatAcquisition(date, time) {
  const d = formatDateBR(date);
  const t = formatTimeUTC(time);
  return [d, t].filter(Boolean).join(" às ") || "Não informado";
}

// FIRMS: VIIRS usa l/n/h; MODIS usa número (0-100)
export function confidenceLabel(value) {
  if (value == null || value === "") return "";
  const v = String(value).toLowerCase();
  if (v === "l" || v === "low") return "Baixa";
  if (v === "n" || v === "nominal") return "Nominal";
  if (v === "h" || v === "high") return "Alta";
  return Number.isFinite(Number(v)) ? `${v}%` : String(value);
}

export function resolveFocusPoints(alert) {
  const list = Array.isArray(alert?.focus_points) ? alert.focus_points : [];
  return list
    .filter((p) => p && p.lat != null && p.lon != null)
    .slice()
    .sort(
      (a, b) =>
        (a.distance_km ?? Number.POSITIVE_INFINITY) -
        (b.distance_km ?? Number.POSITIVE_INFINITY)
    );
}

export function focusLabel(p) {
  if (p.distance_label) return p.distance_label;
  if (p.inside_area) return "DENTRO da propriedade (KML)";
  const d = formatDistanceKm(p.distance_km);
  return d ? `${d} da propriedade (KML)` : "";
}